<template>
  <div class="swa-campaign-quicklink-container">
    <UiCampaignQuicklink
      v-bind="props"
      @campaign-quicklink-clicked="onQuicklinkClicked"
      @campaign-quicklink-impression="onImpressionTracking"
    />
  </div>
</template>

<script lang="ts" setup>
import UiCampaignQuicklink from '@sephora-asia/ui-campaign-quicklink'
import type { CampaignQuickLinkContainerProps } from '~/types/components/contentful/components.types'

const props = defineProps<CampaignQuickLinkContainerProps>()
const { trackEvent } = useGtmTrack()
const { pageType } = usePageMetaStore()
const { path } = useRoute()

function trackQuickLinkEvent(event_type: string, index: number) {
  const campaignCard = props.campaignCards?.[index]

  trackEvent({
    event: `${pageType}_campaign_quicklink_${event_type}`,
    params: {
      quicklink_name: campaignCard?.internalName,
      quicklink_position: index + 1,
      content_banner_position: props.componentPosition,
      page_path: path,
      segmented: !!campaignCard?.isSegmented,
      segments: campaignCard?.segments?.join(','),
    },
  })
}

function onImpressionTracking(index: number) {
  trackQuickLinkEvent('impression', index)
}

function onQuicklinkClicked(index: number) {
  trackQuickLinkEvent('click', index)
}
</script>
<style scoped>
.swa-campaign-quicklink-container {
  padding: 24px 16px;
  background-color: var(--color-base-grey-05);

  .campaign-quicklink {
    margin-inline: auto;
    max-width: 1320px;
  }
}
</style>
